module.exports = __webpack_public_path__ + "static/img/slogan.586da86.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/index1/slogan.png
// module id = QuMJ
// module chunks = 7